// Story 7.6 — twitch_clip card. Thin wrapper over the shared ClipCard.

import { ClipCard } from "./ClipCard";
import type { FeedCard } from "./useFeed";

export function TwitchClipCard({ card }: { card: FeedCard }) {
  return <ClipCard card={card} />;
}
